import React, { Component } from "react";
import { languages, tools, other } from "../skils/skillSet";
import SkillVisualization from "../skils/SkillVisualization";
import "../../styles/skillSectionStyles.css";

class SkillsSection extends Component {
  render() {
    return (
      <section
        className="resume-section p-3 p-lg-5 d-flex align-items-center"
        id="skills"
      >
        <div className="w-100">
          <h2 className="mb-5">Skills & Expertise</h2>
          
          <SkillVisualization 
            skills={languages} 
            title="Programming Languages & Frameworks" 
          />
          
          <SkillVisualization 
            skills={tools} 
            title="Tools & Technologies" 
          />
          
          <SkillVisualization 
            skills={other} 
            title="Other Competencies" 
          />
        </div>
      </section>
    );
  }
}

export default SkillsSection;
